<template>
  <div>
    <v-flex xs12 sm12 md12>
      <v-container grid-list-md fluid>
        <v-layout row>
          <v-flex xs12 sm3 md3>
            <TaskList />
          </v-flex>
          <v-flex xs12 sm9 md9>
            <TaskDetail />
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </div>
</template>
<script>
import TaskList from "../../components/cs/tasks/TaskList";
import TaskDetail from "../../components/cs/tasks/TaskDetail";
export default {
  components: {
    TaskList,
    TaskDetail,
  },
};
</script>
